import { runtime } from '../../Runtime';
export class BrowserHostname {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    get mainHostName() {
        if (runtime.isDevelopmentStage)
            return 'dev.schlaukopf.de';
        if (runtime.isQualityStage)
            return 'qs.schlaukopf.de';
        return 'www.schlaukopf.de';
    }
    get nodeHostName() {
        if (runtime.isDevelopmentStage)
            return 'devnode.schlaukopf.de';
        if (runtime.isQualityStage)
            return 'qsnode.schlaukopf.de';
        return 'node.schlaukopf.de';
    }
}
